<div class="grid grid-gap-5 common-toast border-r-4 {{data.type}} ">
  <button class="icon-btn-basic {{data.type}}"  color="success">
    <mat-icon>{{data.icon}}</mat-icon>
  </button>
  <div class="grid grid-gap-5">
    <div class="f-w-500" *ngIf="!!data?.title">{{data?.title}}</div>
    <div class="{{!!data?.title?'font-14':''}}">{{data?.message}}</div>
  </div>
  <button class="icon-btn-basic {{data.type}}"  (click)="snackBarRef.dismiss();emitHandle();">
    <mat-icon>close</mat-icon>
  </button>
</div>
